import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebase';

interface SendWelcomeEmailOptions {
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  language?: 'en' | 'fr';
  backgroundCheckPassed?: boolean;
  dashboardUrl?: string;
  showInvoiceNotice?: boolean;
  planName?: string;
  totalPaid?: string | number;
  basePrice?: string | number;
  discount?: string | number;
  currency?: string;
  transactionId?: string;
  billingAddress?: string;
  customerName?: string;
  idempotencyKey?: string;
}

const functions = getFunctions(app, 'us-central1');

/**
 * Sends the rich welcome email via the Firebase callable `sendWelcomeEmail`.
 * Supports the bilingual (EN/FR) template with optional invoice/receipt notice.
 */
export async function sendWelcomeEmail(
  options: SendWelcomeEmailOptions,
): Promise<{ emailId?: string } | void> {
  try {
    const fn = httpsCallable<SendWelcomeEmailOptions, { emailId?: string }>(
      functions,
      'sendWelcomeEmail',
    );
    const { data } = await fn(options);
    console.log('[sendWelcomeEmail] ✅ Sent to:', options.email, data);
    return data || undefined;
  } catch (err) {
    console.error('[sendWelcomeEmail] Exception:', err);
    throw err;
  }
}
